import * as React from 'react';
import AudioEditContext, {
	type AudioEditContextType,
} from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Interviews/InterviewDetails/TranscriptReviewSection/Providers/TurnRevisionProvider/Context';

/**
 * Owns the single `TranscriptTurnFormData` instance in play (§9.4): opening a turn seeds it from
 * that turn's own text, submitting compares against the text captured at open time rather than
 * against whatever the store currently holds — the edit is a local draft, independent of any
 * concurrent update. A validation that changes nothing never dispatches, mirroring the server rule
 * (§5.3) and sparing a request for nothing.
 */
const useTurnRevision = (): AudioEditContextType => {
	const context = React.useContext(AudioEditContext);

	if (context === null) {
		throw new Error('useTurnRevision must be used within an TurnRevisionProvider');
	}

	return context;
};

export default useTurnRevision;
